"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 */
exports.toRound = function (num, base) {
    if (num % 1) {
        var percent = Math.pow(10, (base.toString().split('.')[1] || base.toString().split('.')[0]).length);
        return Math.round(num * percent) / percent;
    }
    return num;
};
// Opting out of JS `modulo` calculation due to floating-point problems in JS
// We're looking for the reminder - R.
// x / y = a + R
// R = (x / y) - a | *y
// R = x - (y * a)
// : a = Math.floor(x /y );
/**
 * @hidden
 */
exports.getRemainder = function (x, y) { return x - (y * Math.floor(x / y)); };
/**
 * @hidden
 */
exports.isHalf = function (index, value, step) {
    return (exports.toRound(index - step, step) < value) && (value < index);
};
/**
 * @hidden
 */
exports.isSelected = function (index, value, step, selection) {
    if (value === null) {
        return false;
    }
    if (selection === 'continues') {
        return exports.isHalf(index, value, step)
            ? exports.toRound(index - step / 2, step / 2) <= value
            : index <= value;
    }
    if (selection === 'single') {
        return exports.isHalf(index, value, step)
            ? exports.toRound(index - step / 2, step / 2) === value
            : index === value;
    }
    return false;
};
/**
 * @hidden
 */
exports.calcIsFirstHalf = function (dir, rect, clientX) {
    return dir === 'ltr'
        ? clientX < (rect.x + (rect.width / 2))
        : clientX > (rect.x + (rect.width / 2));
};
/**
 * @hidden
 */
exports.isCorrectValue = function (min, max, step, value) {
    for (var i = min; i <= max; i += step) {
        if (value === i) {
            return true;
        }
    }
    return false;
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-inputs@3.18.0_@progress+kendo-drawing@1.21.2_@progress+kendo-react-anim_73gurhvqk4avqqnlz5vbps7pya/~/@progress/kendo-react-inputs/dist/npm/rating/utils/index.js
// module id = 343
// module chunks = 0